<div class="h-full">
    <ng-container *ngTemplateOutlet="env.ENABLE_TERMS_V2 ? templateV2Ref : templateV1Ref"></ng-container>
</div>

<ng-template #templateV1Ref>
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <div class="ticket">
                <rwidget-terms></rwidget-terms>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #templateV2Ref>
    <div class="flex flex-row items-center justify-between">
        <ion-button
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="handleBackClicked()"
            color="secondary"
            fill="clear">
            <ion-icon
                class="orb-app-light:text-secondary mr-1 text-xl dark:filter-yellow"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
            </ion-icon>
        </ion-button>
        <h1 class="text-base font-bold leading-5">
            {{ 'TERMS_CONDITIONS_TITLE' | translate }}
        </h1>
        <div class="w-12"></div>
    </div>
    <iframe
        class="tnc__iframe h-full"
        [src]="termsUrl$ | async | safeResourceUrl"
        title="{{ 'TERMS_CONDITIONS_TITLE' | translate }}">
    </iframe>
</ng-template>
